module.exports = __webpack_public_path__ + "img/largeScreenRight.03c8d006.png";